import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  {
    q: "Do I need to be home?",
    a: "Not necessarily. As long as we have access to the car, your outdoor tap and a power socket, you don't need to wait around. Many customers leave us to it and come back to a finished car.",
  },
  {
    q: "What if it rains on the day?",
    a: "We'll reach out the night before to check conditions. If heavy rain is forecast we'll reschedule free of charge — your deposit moves with you. Light showers are no problem; we work under cover where possible.",
  },
  {
    q: "How long does each package take?",
    a: "Exterior Wash takes around 1 hour, Interior Detail roughly 1.5 hours, and a Full Detail about 3 hours. Larger or particularly dirty cars may take a little longer.",
  },
  {
    q: "What areas do you cover?",
    a: "We're based in Wolverhampton and cover the wider West Midlands — Birmingham, Coventry, Solihull and surrounding towns as standard. We also take bookings nationwide — get in touch for jobs further afield and we'll work something out.",
  },
  {
    q: "Do I need to provide anything?",
    a: "Just access to your outdoor tap and a nearby power socket on the day. We bring everything else — hoses, extension leads, products, towels, the lot.",
  },
  {
    q: "How do I pay?",
    a: "A £15 fully-refundable deposit is paid securely online via Stripe when you book. The remaining balance is paid in person on the day by cash or card.",
  },
  {
    q: "Can I reschedule or cancel?",
    a: "Yes — just reply to your booking confirmation email or message us on WhatsApp. Your deposit is fully refundable if you cancel 24 hours or more before the booking.",
  },
  {
    q: "Do you do paint correction or ceramic coating?",
    a: "Not yet — but it's on the roadmap. For now we focus on perfecting maintenance washes, interior detailing and full details. Follow us on Instagram for updates.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(null);
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="px-6 md:px-12 lg:px-20 py-28 md:py-36 bg-[#070707] border-t border-white/5"
    >
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-5">
            <div className="overline mb-5">— Questions</div>
            <h2 className="font-display text-4xl sm:text-5xl font-light tracking-tight leading-[1.05]">
              The bits people
              <br />
              <span className="text-white/55">always ask first.</span>
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-white/60 leading-relaxed text-sm">
              Quick answers to the most common questions. Anything else? Drop us a message on
              WhatsApp — we usually reply within a few hours.
            </p>
          </div>
        </div>

        <div className="border-t border-white/10">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q} className="border-b border-white/10">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  data-testid={`faq-toggle-${i}`}
                  className="w-full flex items-start justify-between gap-6 py-6 text-left group"
                >
                  <span className="font-display text-lg sm:text-xl text-white group-hover:text-white/85 transition-colors">
                    {item.q}
                  </span>
                  <span className="mt-1 inline-flex w-8 h-8 items-center justify-center border border-white/15 group-hover:border-white/45 transition-colors flex-shrink-0">
                    {isOpen ? <Minus size={14} /> : <Plus size={14} />}
                  </span>
                </button>
                <div
                  data-testid={`faq-answer-${i}`}
                  className={`overflow-hidden transition-all duration-300 ease-out ${
                    isOpen ? "max-h-64 pb-6" : "max-h-0"
                  }`}
                >
                  <p className="text-white/65 leading-relaxed text-sm max-w-3xl">{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
